<template>
  <v-app>
    <v-main>
      <v-container fill-height>
        <v-row justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-img src="@/assets/images/logo.svg"></v-img>
            <v-card class="mt-10">
              <v-toolbar dark color="primary">
                <v-toolbar-title>Panel administracyjny</v-toolbar-title>
              </v-toolbar>
              <v-alert
                v-if="error"
                text
                prominent
                type="error"
                icon="mdi-alert-circle"
              >
                {{ errorText }}
              </v-alert>
              <v-card-text class="px-10 py-5">
                <v-form ref="login" v-model="valid">
                  <v-text-field
                    @keyup.enter="submit"
                    :rules="notEmptyRule"
                    v-model="login"
                    label="Login"
                    class="mb-5"
                  >
                  </v-text-field>
                  <v-text-field
                    @keyup.enter="submit"
                    :rules="notEmptyRule"
                    v-model="password"
                    label="Hasło"
                    hide-details="auto"
                    type="password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions class="px-10 pb-5">
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  depressed
                  large
                  @click.native="submit(login, password)"
                  :disabled="!valid"
                >
                  Zaloguj
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axiosConf from "../axios-conf";

export default {
  data() {
    return {
      notEmptyRule: [v => !!v || "To pole jest wymagane"],
      login: null,
      password: null,
      valid: false,
      error: false,
      errorText: ""
    };
  },
  methods: {
    submit(login, password) {
      if (this.$refs.login.validate()) {
        this.error = false;
        let data = {
          username: login,
          password: password
        };
        axiosConf
          .post(`login.json`, data)
          .then(response => {
            sessionStorage.setItem("loggedIn", response.data.token);
            sessionStorage.setItem("loggedInUser", login);
            // const pathname = sessionStorage.getItem("pathname");
            // pathname != "" && pathname != "/"
            //   ? this.$router.push(sessionStorage.getItem("pathname"))
            //   : this.$router.push("/dashboard");
            // sessionStorage.removeItem("pathname");
            this.$router.push("/dashboard");
          })
          .catch(err => {
            if (err.response.status === 401) {
              this.errorText =
                "Uwierzytelnienie nie powiodło się. Wykorzystano niepoprawne dane autoryzacyjne. Sprawdź czy login oraz hasło są prawidłowe.";
            } else {
              this.errorText = err.response.data.message;
            }
            this.error = true;
          });
      }
      this.$refs.login.reset();
    }
  }
};
</script>
